import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CollectiveAgreementsSearchComponent } from './collective-agreements-search/collective-agreements-search.component';

export const CollectiveAgreementsRoutes: Routes = [
  { path: '', redirectTo: 'search', pathMatch: 'full' },
  { path: 'search', component: CollectiveAgreementsSearchComponent },
];

@NgModule({
  declarations: [],
  imports: [RouterModule.forChild(CollectiveAgreementsRoutes)],
  exports: [RouterModule],
})
export class CollectiveAgreementsRoutingModule {}
